const ENV = process.env.REACT_APP_ENV || 'development';

const API_CONFIG = {
  development: {
    baseURL: 'https://halalcredapi-production.up.railway.app/api',
  },
  test: {
    baseURL: 'https://halalcredapi-production.up.railway.app/api',
  },
  production: {
    baseURL: 'https://halalcredapi-production.up.railway.app/api',
  }
};

export const getApiUrl = () => API_CONFIG[ENV].baseURL; 